import originAxios from 'axios'
import api from './api.js'
import store from '../store'
import router from '../router'
import Vue from 'vue'
let el = new Vue()

export default function axios(option) {
  // 设置 取消请求的key
  // 说明：传入的参数有 cancelTag key命名是 当前路由名称+cancelTag   // cancelTag 非必传 作用：可保持唯一性
  //       传入的参数没有 cancelTag key命名是 当前路由名称+url
  let routerName = router.history.current.name || ''
  let cancelKey = routerName + '-' + option.url
  if (option.cancelTag) cancelKey = routerName + '-' + option.cancelTag

  if (api[option.url]) option.url = api[option.url]
  !!option.method ? (option.method = option.method) : (option.method = 'post')
  if (option.method.toLowerCase() === 'get') {
    if (!option.params) option.params = option.data
    delete option.data
  }

  // 处理生产环境下不同请求
  if (process.env.NODE_ENV !== 'development') {
    if (option.url.substring(0, 7) === '/:32710') {
      option.url = '/api/v0.5/login' + option.url.slice(7)
    } else if (option.url.substring(0, 7) === '/applet') {
      option.url = '/api/v0.5/applet' + option.url.slice(7)
    } else if (option.url === '/upload') {
      option.url = '/api/v0.5/file' + option.url
    } else if (option.url.substring(0, 1) === '/' && option.url !== '/upload') {
      option.url = '/api/v0.5/backstage/' + option.url.slice(1)
    }
  }

  return new Promise((resolve, reject) => {
    let baseURL = ''
    if (process.env.NODE_ENV !== 'development') {
      // if (option.url !== '/upload') {
      // baseURL = 'https://soujian.datatell.com.cn'
      // } else {
      // baseURL = 'http://gov.eagle.datastory.com.cn/api/v0.5/file'
      // }
    }
    // 1.创建axios的实例
    const instance = originAxios.create({
      baseURL,
      timeout: 0,
    })

    // 配置请求和响应拦截
    instance.interceptors.request.use(
      (config) => {
        let token = localStorage.getItem('token')
        // token="Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIzNmIyYWY1YzI4MDE0YzVkODE4OGFhYjA1ZDQxYTU5YyIsInRyYWRlX2lkIjoiMSIsImNvbXBhbnlfaWQiOiI3YWNiYTVjMzA1Y2E0NzhiYTI4NjQyMjBjNjVmMjhiYSIsInVzZXJfbmFtZSI6IuWImOS8iuWIqTEiLCJleHAiOjE2NDg2MjQzNjIsImF1dGhvcml0aWVzIjoiW10iLCJ1c2VybmFtZSI6InlpbGkxQGVtYWlsLmNvbSJ9.L2RI8iDm8AMoWkqSscaN3zTnTbmJyIj-Ifr5-B3YTNM"
        if (token) config.headers['SJ-TOKEN'] = token
        if (!config.headers['Content-Type'])
          config.headers['Content-Type'] = 'application/json'

        // 请求前取消一样的请求
        store.commit('cancelReq', cancelKey)
        // 保存要取消的请求
        config['cancelToken'] = new originAxios.CancelToken(function (cancel) {
          store.commit('addCancel', {
            keyName: cancelKey,
            cancel,
          })
        })
        return config
      },
      (err) => {
        return err
      },
    )

    instance.interceptors.response.use(
      (response) => {
        if ([50, 51, 52].includes(response.data.code)) {
          let token = localStorage.getItem('token')

          if (token) {
            el.$message({
              message: response.data.message,
              type: 'warning',
            })
          }
          localStorage.removeItem('token')
          setTimeout(() => {
            router.replace({ path: '/login' })
          }, 1000)
        }
        if (
          ['/:32710/login/user', '/api/v0.5/login/login/user'].includes(
            option.url,
          ) &&
          response.data.code === 200
        ) {
          localStorage.setItem('token', response.headers['sj-token'])
        }
        store.commit('removeCancel', cancelKey)
        return response.data
      },
      (err) => {
        store.commit('removeCancel', cancelKey)
        if (err && err.response) {
          switch (err.response.status) {
            case 400:
              err.message = '请求错误'
              break
            case 401:
              err.message = '未授权的访问'
              break
            // case (50, 51, 52):
            //   setTimeout(() => {
            //     router.replace({ path: '/login' })
            //   }, 1000)
            //   break
          }
        }
        throw err
      },
    )

    // 2.传入对象进行网络请求
    instance(option)
      .then((res) => {
        if (res != 'Cancel') resolve(res)
      })
      .catch((err) => {
        console.log(err)
        if (err && err.__CANCEL__) resolve({ code: 200, data: [] })
        reject(err)
      })
  })
}



// WEBPACK FOOTER //
// ./src/http/http.js